module.exports = __webpack_public_path__ + "img/scheme-2.6218d225.png";